import React from 'react'
import styles from './ScoutOfferPattern.module.css'

// 座標はデザイン(幅375)を2倍で書き出した帯画像(幅750)上のpx。描画時は帯に対する%に直す
type Box = { x: number; y: number; w: number; h: number }

type CtaButtonProps = {
    // ボタン・吹き出し部分を白く抜いた帯画像
    bgSrc: string
    bgWidth: number
    bgHeight: number
    button: Box
    // B=角丸の四角 / C・D=ピル型
    shape: 'square' | 'pill'
    text: string
    href: string
    dataClickLabel: string
    // ボタン上に重なる吹き出し（C・Dのみ）。クリック対象にはしない
    badge?: { box: Box; text: string }
}

const toPercent = (box: Box, bgWidth: number, bgHeight: number): React.CSSProperties => ({
    left: `${(box.x / bgWidth) * 100}%`,
    top: `${(box.y / bgHeight) * 100}%`,
    width: `${(box.w / bgWidth) * 100}%`,
    height: `${(box.h / bgHeight) * 100}%`,
})

// DEV-3392 B〜DのCTA。Aの既存ボタン(.upgradeBtnWrap)と同じく、緑の背景は外側のdivに持たせ、
// 文字と矢印だけを<a>に入れる。遷移するのはボタンの上だけで、ホバー時は全体CSS(pages/style.scss)の
// a:hover { opacity: 0.7 } が文字にだけ効き、Aと同じ見え方になる。
export const CtaButton = ({
    bgSrc,
    bgWidth,
    bgHeight,
    button,
    shape,
    text,
    href,
    dataClickLabel,
    badge,
}: CtaButtonProps) => (
    <div className={styles.ctaRow}>
        <img src={bgSrc} alt='' className={styles.strip} />
        <div
            className={`${styles.ctaButton} ${shape === 'pill' ? styles.ctaButtonPill : styles.ctaButtonSquare}`}
            style={toPercent(button, bgWidth, bgHeight)}
        >
            <a
                href={href}
                target='_blank'
                rel='noopener noreferrer'
                data-click-label={dataClickLabel}
            >
                {text}
                <svg viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'>
                    <path
                        d='M4.99981 15C4.74393 15 4.48793 14.9024 4.29293 14.7071C3.9023 14.3164 3.9023 13.6836 4.29293 13.293L9.58736 7.99997L4.29293 2.70709C3.9023 2.31647 3.9023 1.68365 4.29293 1.29302C4.68356 0.902387 5.31638 0.902387 5.70701 1.29302L11.7071 7.29308C12.0977 7.68371 12.0977 8.31653 11.7071 8.70716L5.70701 14.7072C5.51232 14.9032 5.25606 15 4.99981 15Z'
                        fill='#FFFFFF'
                    />
                </svg>
            </a>
        </div>
        {badge && (
            <span className={styles.ctaBadge} style={toPercent(badge.box, bgWidth, bgHeight)}>
                {badge.text}
            </span>
        )}
    </div>
)

export default CtaButton
